import React from 'react';
import PropTypes, { InferProps } from 'prop-types';

import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import TopBar from './TopBar';
import Copyright from './Copyright';
import AuthenticatedAlert from './AuthenticatedAlert';
import AuthTimeoutDisplay from './AuthTimeoutDisplay';
import { useAuthStore } from '../AuthStore';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
}));

type Props = {
  sidebar?: React.ReactNode
}

const propTypes = {
  sidebar: PropTypes.node,
  children: PropTypes.node,
}

const DashboardLayout: React.FC<Props> = ({ sidebar, children }: InferProps<typeof propTypes>) => {
  const classes = useStyles();
  const store = useAuthStore();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <TopBar sidebar={sidebar} />
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        {store.isSuper &&
          <AuthTimeoutDisplay />
        }
        <Container maxWidth={false} className={classes.container}>
          {children}
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
    </div>
  );
};

DashboardLayout.propTypes = propTypes


export default DashboardLayout;
